import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import PhoneInputField from "../../../../components/common/inputFields/PhoneInput";

const PhoneSignin1 = ({ handleSteps, handleSendOtp, setPhone }) => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm();
  const phoneNum = watch("phone_number");

  const [loading, setLoading] = useState(false);

  const onSubmit = async (phone) => {
    handleSendOtp();
  };

  useEffect(() => {
    setPhone(phoneNum);
  }, [phoneNum]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Box className="mb-4">
        <HeadingStyled size="24px" weight="bold" color="var(--text)">
          {t("welcome_back")}
        </HeadingStyled>
        <TextStyled size="16px" color="var(--text2)">
          {t("please_enter_phone_num_for_otp")}
        </TextStyled>
      </Box>
      <Box>
        <Box>
          <PhoneInputField
            weight="600"
            name="phone_number"
            label={"phone"}
            placeholder={"phonePlaceholder"}
            register={register}
            control={control}
            errors={errors}
            validationRules={{
              required: true,
            }}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
          />
          <FormButtonStyled
            label={t("send_otp")}
            color="var(--white)"
            bg="var(--themeColor)"
            className="w-100"
            clName="w-100 my-4"
            type={"submit"}
            isLoading={loading}
          />
        </Box>
      </Box>
    </Form>
  );
};

export default PhoneSignin1;
